import { AmbientLight, MathUtils, Scene, Vector3 } from "three";
import { MouseEvents } from "../../../componets3D/MouseEvents";
import { CameraController } from "../../../componets3D/CameraController";
import { MapSubtopicOne } from "../../objects/Tema4/subtopicOne/MapSubtopicOne";
import ObserverEmitter, { EVENTS } from "../../../../emitter/Observer";
import { CharcterOxxo } from "../../objects/CharacterOxxo";
import { Monitor } from "../../objects/Tema4/subtopicOne/monitor";
import { Teclado } from "./teclado";
import { Billetes } from "../../objects/Tema4/subtopicOne/billetes";
import { Moneda } from "../../objects/Tema4/subtopicOne/moneda";
import { Moneda5 } from "../../objects/Tema4/subtopicOne/moneda5";
import { PanelesBilletesQuizTwo } from "../../objects/Tema4/subtopicOne/panelesBilletesQuizTwo";

export class SceneTopicFive extends Scene {
	constructor(loadingManager, container, render, character = new CharcterOxxo(), enviroment) {
		super();
		this.camera = new CameraController();
		this.environment = enviroment;
		this.characterSelected = character;
		this.loadingManager = loadingManager;
		this.mouseEvents = new MouseEvents(container, render, this.camera, this);
		this.create();
		this.light();
		// this.helper();
		this.renderAnimations();
		this.observerListeners();
	}
	create() {
		this.add(this.characterSelected);

		this.mapmenu = new MapSubtopicOne(this.loadingManager);
		this.add(this.mapmenu);

		this.monitor = new Monitor(this.loadingManager);
		this.monitor.visible = false;
		this.add(this.monitor)

		this.teclado = new Teclado(this.loadingManager);
		this.teclado.visible = false
		this.add(this.teclado)

		this.BilleteOne = new Billetes(this.loadingManager);
		this.BilleteOne.visible = false
		this.add(this.BilleteOne)

		this.BilleteTwo = new Billetes(this.loadingManager);
		this.BilleteTwo.visible = false
		this.add(this.BilleteTwo)

		this.BilleteThree = new Billetes(this.loadingManager);
		this.BilleteThree.visible = false
		this.add(this.BilleteThree)

		this.Moneda = new Moneda(this.loadingManager);
		this.Moneda.visible = false
		this.add(this.Moneda)

		this.MonedaTwo = new Moneda5(this.loadingManager);
		this.MonedaTwo.visible = false
		this.add(this.MonedaTwo)

		this.MonedaThree = new Moneda5(this.loadingManager);
		this.MonedaThree.visible = false
		this.add(this.MonedaThree)

		this.panelesBilletesQuiz = new PanelesBilletesQuizTwo(this.loadingManager);
		this.panelesBilletesQuiz.visible = false
		this.add(this.panelesBilletesQuiz)
	}

	SceneInitialState() {
		this.mouseEvents.disposeInteractions();
	}

	activeAudio() {
		ObserverEmitter.emit(EVENTS.audioInitByTopic)
	}

	ActivitiSelected(activity) {
		switch (activity) {
			case 1:
				this.camera.moveCameraToPoint(new Vector3(-12.5158, -0.2328, -1.8734), 1, new Vector3(-11.493, -0.366, -1.905), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = false;
					this.camera.control.maxAzimuthAngle = Infinity;
					this.camera.control.minAzimuthAngle = Infinity;
					this.camera.control.minDistance = 1;
					this.camera.control.minAzimuthAngle = -1.126;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.enablePan = false;

					this.characterSelected.visible = true;
					this.characterSelected.onAnimationFestejo();
					this.characterSelected.position.set(-10.5846, -0.9809, -1.9341);
					this.characterSelected.rotation.y = -1.6466;
					this.activeAudio()
				});
				break;
			case 2:
				this.camera.moveCameraToPoint(new Vector3(-12.5158, -0.2328, -1.8734), 1, new Vector3(-11.493, -0.366, -1.905), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = false;
					this.camera.control.maxAzimuthAngle = Infinity;
					this.camera.control.minAzimuthAngle = Infinity;
					this.camera.control.minDistance = 1;
					this.camera.control.minAzimuthAngle = -1.126;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.enablePan = false;

					this.characterSelected.visible = true;
					this.characterSelected.onAnimationFestejo();
					this.characterSelected.position.set(-10.5846, -0.9809, -1.9341);
					this.characterSelected.rotation.y = -1.6466;
					this.activeAudio()

					this.mouseEvents.disposeInteractions();
					this.mouseEvents.objectsToValue = [];
				});
				break;
			default:
				this.camera.control.maxAzimuthAngle = Infinity;
				this.camera.control.minAzimuthAngle = Infinity;
				this.camera.moveCameraToPoint(new Vector3(-12.5158, -0.2328, -1.8734), 1, new Vector3(-11.493, -0.366, -1.905), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = false;
					this.camera.control.maxAzimuthAngle = -0.86;
					this.camera.control.minAzimuthAngle = -2;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.enablePan = false;

					this.characterSelected.visible = false
					this.activeAudio()
				});
				break;
		}
	}

	light() {
		this.ambient = new AmbientLight();
		this.ambient.color.set(0xffffff);
		this.ambient.intensity = 1;
		this.add(this.ambient);
	}

	observerListeners() {
		ObserverEmitter.on(EVENTS.tema4.subtopicThree.activityTwo.moveCameraToMonitor, () => {
			this.camera.control.maxAzimuthAngle = Infinity;
			this.camera.control.minAzimuthAngle = Infinity;
			this.camera.moveCameraToPoint(new Vector3(-12.2665, 0.0093, 2.7979), 1, new Vector3(-10.716, 0, 2.752), () => {
				this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
				this.camera.control.minPolarAngle = MathUtils.degToRad(20);
				this.camera.control.minDistance = 1.4;
				this.camera.control.maxDistance = 2;

				this.characterSelected.visible = false
			});
		})
		ObserverEmitter.on(EVENTS.tema4.subtopicOne.activityTwo.returnToDesk, () => {
			this.camera.control.maxAzimuthAngle = Infinity;
			this.camera.control.minAzimuthAngle = Infinity;
			this.camera.moveCameraToPoint(new Vector3(-12.5158, -0.2328, -1.8734), 1, new Vector3(-11.493, -0.366, -1.905), () => {
				this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
				this.camera.control.minPolarAngle = MathUtils.degToRad(20);
				this.camera.control.enableRotate = false;
				this.camera.control.maxAzimuthAngle = Infinity;
				this.camera.control.minAzimuthAngle = -1.126;
				this.camera.control.minDistance = 1;
				this.camera.control.maxDistance = 3;
				this.camera.control.enablePan = false;

				this.characterSelected.visible = true
			});
		})
		ObserverEmitter.on(EVENTS.tema4.subtopicOne.activityTwo.moveCameraWithNeto, () => {
			this.camera.control.maxAzimuthAngle = Infinity;
			this.camera.control.minAzimuthAngle = Infinity;
			this.camera.moveCameraToPoint(new Vector3(-7.0293, -0.1354, -0.8723), 1, new Vector3(-8.026, -0.213, -0.876), () => {
				this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
				this.camera.control.minPolarAngle = MathUtils.degToRad(20);
				this.camera.control.enableRotate = false;
				this.camera.control.maxAzimuthAngle = Infinity;
				this.camera.control.minAzimuthAngle = -1.126;
				this.camera.control.minDistance = 1;
				this.camera.control.maxDistance = 3;
				this.camera.control.enablePan = false;

				this.characterSelected.visible = false
			});
		})
		ObserverEmitter.on(EVENTS.tema4.subtopicFour.activityThree.moveCameraToBillets, () => {
			this.camera.control.maxAzimuthAngle = Infinity;
			this.camera.control.minAzimuthAngle = Infinity;
			this.camera.moveCameraToPoint(new Vector3(-11.9594, -0.3951, -0.7619), 1, new Vector3(-11.21, -1.057, -0.763), () => {
				this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
				this.camera.control.minPolarAngle = MathUtils.degToRad(20);
				this.camera.control.enableRotate = false;
				this.camera.control.maxAzimuthAngle = Infinity;
				this.camera.control.minAzimuthAngle = -1.126;
				this.camera.control.minDistance = 0.8;
				this.camera.control.maxDistance = 1;
				this.camera.control.enablePan = false;

				this.characterSelected.visible = false
			});
		})
		ObserverEmitter.on(EVENTS.tema4.subtopicFive.activityTwo.changeActivity, () => {
			this.BilleteOne.visible = true
			this.BilleteOne.rotation.set(0, 0, 0)
			this.BilleteOne.position.set(-11.25, -0.98, -1.05)
			this.BilleteOne.Billetes.name = "BilleteOne"

			this.BilleteTwo.visible = true
			this.BilleteTwo.rotation.set(0, 0, 0)
			this.BilleteTwo.position.set(-11.25, -0.98, -0.45)
			this.BilleteTwo.Billetes.name = "BilleteThree"

			this.BilleteThree.visible = true
			this.BilleteThree.rotation.set(0, 0, 0)
			this.BilleteThree.position.set(-11.3, -0.96, -0.4)
			this.BilleteThree.Billetes.name = "BilleteFour"

			this.Moneda.visible = true
			this.Moneda.scale.set(5, 5, 5)
			this.Moneda.position.set(-11.4, -0.96, -1.11)

			this.MonedaTwo.visible = true
			this.MonedaTwo.scale.set(5, 5, 5)
			this.MonedaTwo.position.set(-11.25, -0.96, -0.725)

			this.MonedaThree.visible = true
			this.MonedaThree.scale.set(5, 5, 5)
			this.MonedaThree.position.set(-11.4, -0.96, -0.775)

			this.teclado.visible = true
			this.teclado.position.set(-11.2224, -0.99, -1.8533)
			this.panelesBilletesQuiz.visible = true

			this.mouseEvents.disposeInteractions();
			this.mouseEvents.objectsToValue = [
				this.BilleteOne,
				this.BilleteTwo,
				this.BilleteThree,
				this.Moneda,
				this.MonedaTwo,
				this.MonedaThree,
			];
			this.mouseListenersActivityTwo()
		})
	}
	mouseListenersActivityTwo() {
		// This variable validate the user answer
		let selectedChange;

		this.mouseEvents.onPointerUp((interactions) => {
			if (interactions[0]) {
				const name = interactions[0].object.name;
				ObserverEmitter.emit(EVENTS.activeButtonValidate, true)
				switch (name) {
					// Option A
					case 'BilleteOne':
					case 'Moneda10':
						this.BilleteOne.onClose()
						this.Moneda.onClose()
						this.BilleteTwo.onFurther()
						this.BilleteThree.onFurther()
						this.MonedaTwo.onFurther()
						this.MonedaThree.onFurther()
						this.panelesBilletesQuiz.onElevate(this.panelesBilletesQuiz.OptionA)
						this.panelesBilletesQuiz.onDrop(this.panelesBilletesQuiz.OptionB)
						this.panelesBilletesQuiz.onDrop(this.panelesBilletesQuiz.OptionC)
						selectedChange = name
						break;
					// Option B -- correct option
					case 'Moneda5':
						this.MonedaTwo.onClose()
						this.MonedaThree.onClose()
						this.BilleteOne.onFurther()
						this.Moneda.onFurther()
						this.BilleteTwo.onFurther()
						this.BilleteThree.onFurther()
						this.panelesBilletesQuiz.onElevate(this.panelesBilletesQuiz.OptionB)
						this.panelesBilletesQuiz.onDrop(this.panelesBilletesQuiz.OptionA)
						this.panelesBilletesQuiz.onDrop(this.panelesBilletesQuiz.OptionC)
						selectedChange = name
						break;
					// Option C
					case 'BilleteThree':
					case 'BilleteFour':
						this.BilleteTwo.onClose()
						this.BilleteThree.onClose()
						this.BilleteOne.onFurther()
						this.Moneda.onFurther()
						this.MonedaTwo.onFurther()
						this.MonedaThree.onFurther()
						this.panelesBilletesQuiz.onElevate(this.panelesBilletesQuiz.OptionC)
						this.panelesBilletesQuiz.onDrop(this.panelesBilletesQuiz.OptionA)
						this.panelesBilletesQuiz.onDrop(this.panelesBilletesQuiz.OptionB)
						selectedChange = name
						break;
					default:
						break;
				}
			}
			if (selectedChange === "Moneda5") {
				ObserverEmitter.on(EVENTS.tema4.subtopicFive.activityTwo.respondChangeActivity, () => {
					ObserverEmitter.emit(EVENTS.tema4.subtopicOne.activityTwo.returnToDesk)
					ObserverEmitter.emit(EVENTS.tema4.subtopicFive.activityTwo.validateChangeActivity, true)
					this.teclado.visible = false
					this.Moneda.onFurther()
					this.MonedaTwo.onFurther()
					this.MonedaThree.onFurther()
					this.BilleteOne.onFurther()
					this.BilleteTwo.onFurther()
					this.BilleteThree.onFurther()
					this.Moneda.visible = false
					this.MonedaTwo.visible = false
					this.MonedaThree.visible = false
					this.BilleteOne.visible = false
					this.BilleteTwo.visible = false
					this.BilleteThree.visible = false
					this.panelesBilletesQuiz.onDrop(this.panelesBilletesQuiz.OptionA)
					this.panelesBilletesQuiz.onDrop(this.panelesBilletesQuiz.OptionB)
					this.panelesBilletesQuiz.onDrop(this.panelesBilletesQuiz.OptionC)
					this.panelesBilletesQuiz.visible = false
				})
			} else {
				ObserverEmitter.on(EVENTS.tema4.subtopicFive.activityTwo.respondChangeActivity, () => {
					ObserverEmitter.emit(EVENTS.tema4.subtopicOne.activityTwo.returnToDesk)
					ObserverEmitter.emit(EVENTS.tema4.subtopicFive.activityTwo.validateChangeActivity, false)
					this.teclado.visible = false
					this.Moneda.onFurther()
					this.MonedaTwo.onFurther()
					this.MonedaThree.onFurther()
					this.BilleteOne.onFurther()
					this.BilleteTwo.onFurther()
					this.BilleteThree.onFurther()
					this.Moneda.visible = false
					this.MonedaTwo.visible = false
					this.MonedaThree.visible = false
					this.BilleteOne.visible = false
					this.BilleteTwo.visible = false
					this.BilleteThree.visible = false
					this.panelesBilletesQuiz.onDrop(this.panelesBilletesQuiz.OptionA)
					this.panelesBilletesQuiz.onDrop(this.panelesBilletesQuiz.OptionB)
					this.panelesBilletesQuiz.onDrop(this.panelesBilletesQuiz.OptionC)
					this.panelesBilletesQuiz.visible = false
				})
			}
		});
	}
	renderAnimations(delta) {
		//animaciones
	}
}